import styled, { css } from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import tickIcon from '../Icons/tick-icon.svg'

export const P = styled.p`
  margin: 0;
  ${ifProp('pass', css`
    color: #53b260;
  `)}
`

export const List = styled.ul`
  margin: .5em 0;
  padding: 0;
  list-style: none;
`
export const ListItem = styled.li`
  position: relative;
  margin-bottom: .25em;
  padding-left: 1.5em;

  &::before {
    content: ${ifProp('pass', '""', '"•"')};
    position: absolute;
    left: .25em;
    width: 1em;
    height: 1em;
    text-align: center;
    ${ifProp('pass', css`
      background: url(${tickIcon}) center no-repeat;
      background-size: 90%;
    `)}
  }
  ${ifProp('pass', css`
    color: #53b260;
  `)}
`
